import React from "react";

// eslint-disable-next-line import/no-named-as-default
import { ProductProvider } from "./pages/Product/ProductContext";

import { VendorProvider } from "./pages/Vendor/VendorContext";
import { UserProvider } from "./pages/UserContext";
import { NotificationProvider } from "./pages/Notification/NotificationContext";
import RouterShell from "./RouterShell";

export default function App() {
  return (
    <UserProvider>
      <NotificationProvider>
        <VendorProvider>
          <ProductProvider>
            <RouterShell />
          </ProductProvider>
        </VendorProvider>
      </NotificationProvider>
    </UserProvider>
  );
}
